import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Box } from '@material-ui/core';

export const CHeader = ({ children, classes }) => {
    return (
        <Box className={classes.root}>
            {children}
        </Box>
    );
};

CHeader.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.shape({
        root: PropTypes.string
    }).isRequired
};

export const CNavLink = ({ children, to, href, isExact, target }) => {
    if (href) {
        return (
            <a href={href} target={target}>
                {children}
            </a>
        )
    }
    return (
        <NavLink exact={isExact || false} to={to}>
            {children}
        </NavLink>
    );
};

CNavLink.propTypes = {
    children: PropTypes.node,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    href: PropTypes.string,
    isExact: PropTypes.bool,
    target: PropTypes.string
};
